export default __webpack_public_path__ + "img/caret-up-black.9fdc3bcc.svg";